import Button from "../../../../common/components/atom/Button/Button";
import TextInput from "../../../../common/components/atom/TextInput/TextInput";
import MessageCard from "../../../../common/components/molecule/MessageCard/MessageCard";
import { ErrorStatusResetPasswordRequest, FormDataResetPasswordRequest } from "./ResetPasswordRequestForm";

import styles from "./ResetPasswordRequestFormView.module.scss";


export interface NewOrganizationFormViewProps {
  formData?: FormDataResetPasswordRequest;
  setFormData: (key: keyof FormDataResetPasswordRequest, value: string) => void;
  errorStatus?: ErrorStatusResetPasswordRequest;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  onClickCancel?: () => void;
}

export const ResetPasswordUserFormView = ({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Modifier votre mots de passe",
  description = "",
  maxWidth = "700px",
  title,
  formData,
  setFormData,
  onClickCancel
}: NewOrganizationFormViewProps) => {
  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Email"
              value={formData?.email}
              error={errorStatus?.isErrorEmail}
              onChange={(e) => {
                setFormData("email", e.target.value);
              }}
              type="email"
            />
          </div>

          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
            { !isLoading && onClickCancel &&
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                onClick={onClickCancel}
                variant={"tertiary"}
                
              >
                Annuler
              </Button>
            </div>
  }
          </div>
        </form>
      </div>
    </div>
  );
};
